export const wrapper = () => ({
    padding: '32px 30px',
});
